import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ContentPlaceholderAnimationComponent } from './content-placeholder-animation/content-placeholder-animation.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { LayoutComponent } from './layout/layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { QButtonComponent } from './qbutton/qbutton.component';
import { MatStepperModule } from '@angular/material/stepper';
import { QTableComponent } from './qtable/qtable.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { LayoutSimpleComponent } from './layout-simple/layout-simple.component';
import { QDialogComponent } from './qdialog/qdialog.component';

@NgModule({
    imports: [
        RouterModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule, 
        MatStepperModule,
        MatPaginatorModule
    ],
    declarations: [
        ConfirmDialogComponent,
        ContentPlaceholderAnimationComponent,
        LimitToPipe,
        LocalDatePipe,
        YesNoPipe,
        LayoutComponent,
        LayoutSimpleComponent,
        QDialogComponent,
        QButtonComponent,
        QTableComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,        
        CustomMaterialModule,
        LimitToPipe,
        ConfirmDialogComponent,
        ContentPlaceholderAnimationComponent,
        LocalDatePipe,
        YesNoPipe,
        TranslateModule,
        QButtonComponent, 
        MatStepperModule,
        QTableComponent,
        QDialogComponent
    ]
})
export class SharedModule { }
